<template>
    <console-layout width="100%" max-width="600">

        <console-title>
            <span v-if="$route.params._admin">관리자 상세</span>
            <span v-else>관리자 생성</span>
        </console-title>

        <console-body>
            <v-card>
                <v-card-title class="subtitle-2">기본정보</v-card-title>
                <v-card-text>
                    <v-text-field v-model="admin.username" label="아이디" persistent-placeholder hide-details class="mt-4"></v-text-field>
                    <v-password-field v-model="admin.password" label="비밀번호" persistent-placeholder hide-details class="mt-4"></v-password-field>
                </v-card-text>
                <v-divider />
                <v-card-text>
                    <v-text-field v-model="admin.name" label="담당자(이름)" persistent-placeholder hide-details></v-text-field>
                    <v-text-field v-model="admin.phone" label="담당자(연락처)" persistent-placeholder hide-details class="mt-4"></v-text-field>
                    <v-text-field v-model="admin.email" label="담당자(이메일)" persistent-placeholder hide-details class="mt-4"></v-text-field>
                </v-card-text>
                <v-divider />
                <v-card-text>
                    <v-text-field v-model="admin.postcode" label="우편번호" persistent-placeholder hide-details></v-text-field>
                    <v-text-field v-model="admin.address1" label="기본주소" persistent-placeholder hide-details class="mt-4"></v-text-field>
                    <v-text-field v-model="admin.address2" label="상세주소" persistent-placeholder hide-details class="mt-4"></v-text-field>
                </v-card-text>
                <v-divider />
                <v-card-text>
                    <v-text-field v-model="admin.ci" label="ci" persistent-placeholder hide-details></v-text-field>
                </v-card-text>
                <v-card-actions />
            </v-card>
        </console-body>

        <v-row class="my-4">
            <v-spacer/>
            <v-col cols="auto">
                <v-btn color="primary" @click="save">저장</v-btn>
            </v-col>
            <v-spacer/>
        </v-row>

    </console-layout>
</template>

<script>
import api from "@/api";
import CryptoAES from "@/plugins/crypto-aes";
import VPasswordField from "@/components/plugins/vuetify/v-password-field.vue";
import { mdiMicrosoftExcel } from "@mdi/js";

export default {
    components: {
        VPasswordField
    },
    data(){
        return {
            mdiMicrosoftExcel,

            showSearch: true,

            admin: {
                username: null,
                password: null,
                name: null,
                phone: null,
                email: null,
                postcode: null,
                address1: null,
                address2: null,
            }
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            if(this.$route.params._admin){
                let { admin } = await api.console.admins.get({ _id: this.$route.params._admin });
                this.admin = {
                    ...this.admin,
                    ...admin
                };
            }
        },

        async save(){
            this.admin._id
            ? await api.console.admins.put({
                ...this.admin,
                password: this.admin.password ? CryptoAES.encrypt(this.admin.password) : undefined
            })
            : await api.console.admins.post({
                ...this.admin,
                password: this.admin.password ? CryptoAES.encrypt(this.admin.password) : undefined
            });

            alert("저장되었습니다");
            this.$router.push(`/console/admins`);
        }
    }
}
</script>